<template>
  <div class="page">
    <el-page-header @back="onBack" title="" content="年級銷售統計"></el-page-header>
    <div class="page-content">
        <el-form :model="from" label-position="left" label-width="80px"  :rules="rules" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="訂單日期" prop="date">
            <el-date-picker
              v-model="from.date"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="年級" prop="gradeId">
            <el-select v-model="from.gradeId" placeholder="全部">
              <el-option
                v-for="item in allGrades"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="info" @click="onExport">導出</el-button>
          </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import {downloadFile} from '@/utils/is-rules'
import {getGradeSaleReport} from '@/api/report'
import {getGrades} from '@/api/grade'
export default {
  data() {
    return {
      allGrades: [],
      from: {
        date: [],
        gradeId: null,
      },
      rules:{
        date: [
          { required: true, message: '請選擇日期', trigger: 'change' }
        ],
        gradeId:[{ required: true, message: '請選擇年級', trigger: 'change' }],
      }
    };
  },
  created() {
    this.getAllGrades()
  },
  methods: {
    getAllGrades(){
        let formLabelAlign = {
          _page: 0,
          _limit: 0,
        }
       getGrades(formLabelAlign).then((v)=>{
          this.allGrades = v.data
       })
    },
    onExport(){
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.getGradeSaleReport()
        }
      })
    },
    getGradeSaleReport(){
      let formLabelAlign = {
            startDate: this.from.date[0],
            endDate: this.from.date[1],
            gradeId: this.from.gradeId,
          }
      getGradeSaleReport(formLabelAlign).then((v)=>{
        downloadFile(v.data,'年級銷售統計.xlsx')
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.el-page-header{
  margin-bottom: 20px;
}
.page-title{
  margin-bottom: 20px;
}
.page-content{
  background-color: #fff;
  padding: 20px;
}
</style>